import { render, staticRenderFns } from "./Ciaz.vue?vue&type=template&id=5c9d41b4&"
import script from "./Ciaz.vue?vue&type=script&lang=ts&"
export * from "./Ciaz.vue?vue&type=script&lang=ts&"
import style0 from "./Ciaz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports